import { isHumanTasksFixturesMode } from '../helpers/fixtures-mode';
import { humanTasksRestApi } from './human-tasks-api';
import { fixturesHumanTasks } from './fixtures-human-tasks';

/**
 * The service every query and action of Inicio goes through, resolved on each
 * call: the real `/human-tasks/*` API, or the in-memory example data when
 * `REACT_APP_HUMAN_TASKS_FIXTURES=true` (local review only). Both expose the
 * same methods and answer with the same body shapes.
 */
export const getHumanTasksService = () => (isHumanTasksFixturesMode() ? fixturesHumanTasks : humanTasksRestApi);

export default getHumanTasksService;
